import React, { Component } from "react";

class ColorField extends Component {
  constructor(props){
    super(props)
    this.state={value:"#EE0000"}
    this.onChange=this.onChange.bind(this)
  }

  onChange(evt){
    this.setState({value:evt.target.value})
    this.props.input.onChange(evt.target.value)
    // console.log("COLOR", evt.target.value, this.props.meta)
  }

  render() {
    // console.log("COLOR FIELD PROPS", this.props)
    return (
      <div className="MuiInput-Base-root MuiInput-root MuiInput-underline display-flex">
        {/* <label>{this.state.value}</label> */}
        <input {...this.props.input}
          className="MuiInput-input color-selector"
          type="color"
        />
        <input {...this.props.input} className="MuiInputBase-input MuiInput-input"/>
         
      </div>
      
    );
  }
};

export default ColorField;



// WEBPACK FOOTER //
// ./src/components/ColorField/ColorField.js